import React from 'react';
import styles from '../../assets/styles/AppHome/ThisWeekCard.module.scss';
import { ThisWeekComponent as TWC } from '../../components/Home';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';

const ThisWeekCard = ({ summary }) => {
	const navigate = useNavigate();
	return (
		<div className={styles.tw}>
			<h4 className={styles.tw__title}>This Week</h4>
			<div className={styles.tw__content}>
				<TWC onClick={()=> navigate(constant.Routes.Transactions)} title="Transactions" amount={summary.transactionCount} />
				<TWC onClick={()=> navigate(constant.Routes.Customer)} title="Customers" amount={summary.customerCount} />
				<TWC onClick={()=> navigate(constant.Routes.Invoice)} title="Invoices Generated" amount={summary.invoiceCount} />
				<TWC onClick={()=> navigate(constant.Routes.Invoice)} title="Receipts Generated" amount={summary.receiptCount} />
			</div>
		</div>
	);
};

export default ThisWeekCard;
